var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-bs",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bs-a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M-12 0h640v480H-12z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#bs-a)",
    transform: "translate(12)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M968.5 480h-979V1.8h979z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe900",
    d: "M968.5 344.5h-979V143.3h979z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#08ced6",
    d: "M968.5 480h-979V320.6h979zm0-318.7h-979V2h979z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M-11 0c2.3 0 391.8 236.8 391.8 236.8L-12 479.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBs);
export default __webpack_public_path__ + "static/media/bs.056e551cfb3bba660804eec90aff9866.svg";
export { ForwardRef as ReactComponent };